import { Controller } from "@hotwired/stimulus";

// data-controller="window-manager"
export default class extends Controller {
}
